/** RSOC article generation language codes (ISO 639-1). */
export const KLOW_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "de", label: "German" },
  { code: "pl", label: "Polish" },
  { code: "es", label: "Spanish" },
  { code: "fr", label: "French" },
  { code: "it", label: "Italian" },
  { code: "pt", label: "Portuguese" },
  { code: "nl", label: "Dutch" },
] as const

export type KlowLanguageCode = (typeof KLOW_LANGUAGES)[number]["code"]

export const DEFAULT_KLOW_LANGUAGE: KlowLanguageCode = "en"
